import React from "react";
import HolidayRuleFormModal from "./HolidayRuleFormModal";

const UpdateHolidayRule = (props) => {
  return <HolidayRuleFormModal { ...props } />;
};

export default UpdateHolidayRule;
